enum MemberTypes {
  SET_THIS_SESSION_MEMBER = '[MEMBER] SET_THIS_SESSION_MEMBER',
}

export default MemberTypes;
